import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from "./App";
import { CommonProvider } from '@common/context'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Router>
          <CommonProvider>
              <App />
          </CommonProvider>
      </Router>
  </React.StrictMode>
);
